import React from 'react';
import {
  AreaChart as RechartsAreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

interface AreaChartProps {
  data: any[];
  xKey: string;
  yKey: string;
  areaColor?: string;
  height?: number;
}

const AreaChart: React.FC<AreaChartProps> = ({
  data,
  xKey,
  yKey,
  areaColor = '#3B82F6',
  height = 300,
}) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsAreaChart
        data={data}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xKey} />
        <YAxis />
        <Tooltip />
        <Area type="monotone" dataKey={yKey} stroke={areaColor} fill={areaColor} fillOpacity={0.3} />
      </RechartsAreaChart>
    </ResponsiveContainer>
  );
};

export default AreaChart;